export const state = {
  amount: null,
  apr: null,
  payment: null,
  term: null
};
